import React, { useState, useEffect } from 'react'
import { Cooks, currentWeekPrev, weekNumbers } from '../../api/routes';
import ReceptChooseDialog from '../recept/ReceptChooseDialog';
import './styles.css'
import FormWrapper from '../components/FormWrapper/FormWrapper';

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect'
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';

const weekDays = ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag', 'Välj Dag']


export default function CreateCookDialog(props) {
  const [open, setOpen] = useState(false);
  const [newCook, setNewCook] = useState(true)

  const weeks = weekNumbers()

  const genCook = () => {
    const {order} = props
    const _cook = {
      smak: order.smak, subSmak: "", sort: order.sort, batch: 0,
      dag: "Okej", kommentar: "", orderID: order.id, done: false, toFrys: false,
      type: order.type, prio: 1, subSmaker: order.subSmaker, week: currentWeekPrev(), year: new Date().getFullYear(),
    }
    return _cook
  }

  const [cook, setCook] = useState(genCook())

  useEffect(() => {
    checkIfExist()
  }, [])
  useEffect(() => {
    checkIfExist()
  }, [props.renderButtons])


  useEffect(() => {
    setCook(genCook())
  }, [props.order])

  const handleClickOpen = async () => {
    if (props.isAdmin()) {
      checkIfExist()
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleUpdate = (name, value) => {
    const _cook = { ...cook }
    _cook[name] = value
    setCook(_cook)
  }
  const handleUpdateDay = e => {
    const _cook = { ...cook }
    if(_cook.day_index !== 7) {
    _cook.day_index = e.target.value
    _cook.dag = weekDays[e.target.value]
    } else {
      _cook.day_index = 0
      _cook.dag = weekDays[0]
    }
    setCook(_cook)
  }
  const handleUpdateArray = (arr) => {
    const _cook = { ...cook }
    arr.map(item => _cook[item.name] = item.value)
    setCook(_cook)
  }
  const handleUpdateEvent = e => {
    const { name, value } = e.target
    const _cook = { ...cook }
    _cook[name] = value
    setCook(_cook)
  }

  const handleDelete = async () => {
    if (window.confirm('Är du säker att du vill radera denna order?')) {
      setNewCook(true)
      handleClose()
      handleUpdate('dag', 'Okej')
      await Cooks.Delete(cook)
      await props.getData()
    };
  }

  const handleCreate = async () => {
    const _cook = { ...cook }
    _cook.dag = weekDays[_cook.day_index]

    handleClose()
    if (newCook) await Cooks.Create(_cook)
    else await Cooks.Update(_cook)
    // await props.getData()
  }

  const checkIfExist = async () => {
    const arr = await Cooks.ReadByOrderID(props.order.id)
    if (arr.length > 0) {
      // filtrerar ut rätt vecka och ej färdigställda samt sorterar på dag
      const _arr = arr.filter(item => item.week == currentWeekPrev() && !item.done)
      _arr.sort(function(a, b) { return a.day_index - b.day_index })

      const latest = _arr[0]
      // setCook(latest)
      // setNewCook(false)
      if(latest) {
        const _cook = {...cook}
        _cook.dag = latest.dag
        setCook(_cook)
      }
    }
  }

  const isBland = props.order.type == 'Bland'

  const buttonStyle = cook.dag == 'Okej' ? '#04a466' : '#2980b9'

  const underSmakSelect = <FormControl variant="standard">
    <InputLabel id="demo-simple-select-label">Undersmak</InputLabel>
    <NativeSelect
      value={cook.subSmak}
      name="subSmak"
      onChange={handleUpdateEvent}
      inputProps={{ name: 'subSmak', id: 'uncontrolled-native', }}
    >{props.order.subSmaker.filter(item => item !== '').map(item => <option key={item} value={item}>{item}</option>)}
    </NativeSelect>
  </FormControl>

  return (
    <div>
      <FormWrapper label="Kokning">
        <div className="CreateCookDialog__button" onClick={handleClickOpen} style={{ backgroundColor: buttonStyle }}>{cook.dag}</div>
      </FormWrapper>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Planera en kokning</DialogTitle>
        <DialogContent className="CreateOrderDialog__form">
          <div className="flex">
            <TextField
              id="standard-basic" label="Smak" variant="standard"
              onChange={handleUpdateEvent}
              value={cook.smak}
              name="smak"
              InputProps={{ readOnly: true, }}
            />
            {isBland && <div className="spacer-5" />}
            {isBland && underSmakSelect}

            <div className="spacer-5" />
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Typ</InputLabel>
              <NativeSelect
                value={cook.sort}
                name="sort"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'sort', id: 'uncontrolled-native', }}
              >{['Sort', 'Tryffel', 'Nougat', 'Kola', 'Flera'].map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>

            <div className="spacer-5" />
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Batch</InputLabel>
              <NativeSelect
                value={cook.batch}
                name="batch"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'batch', id: 'uncontrolled-native', }}
              >{[...Array(7).keys()].map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>

            <div className="spacer-5" />
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Planerad Dag</InputLabel>
              <NativeSelect
                value={cook.day_index}
                name="day_index"
                onChange={handleUpdateDay}
                inputProps={{ name: 'day_index', id: 'uncontrolled-native', }}
              >{[7, 0, 1, 2, 3, 4, 5, 6].map(item => <option key={item} value={item}>{weekDays[item]}</option>)}
              </NativeSelect>
            </FormControl>
            <div className="spacer-5" />

            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Vecka</InputLabel>
              <NativeSelect
                value={cook.week}
                name="week"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'week', id: 'uncontrolled-native', }}
              >{weeks.map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>

            <div className="spacer-5" />

            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">År</InputLabel>
              <NativeSelect
                value={cook.year}
                name="year"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'year', id: 'uncontrolled-native', }}
              >{['2023', '2024', '2025', '2026'].map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>
          </div>

          <div className="spacer-5" />

          <div className="flex">
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Prio</InputLabel>
              <NativeSelect
                value={cook.prio}
                name="prio"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'prio', id: 'uncontrolled-native', }}
              >{[[1, 'Låg'], [2, 'Medel'], [3, 'Hög']].map(item => <option key={item[0]} value={item[0]}>{item[1]}</option>)}
              </NativeSelect>
            </FormControl>
            <div className="spacer-5" />

            {/* <FormWrapper label="Till Frysen">
              <Switch
                checked={cook.toFrys}
                name="toFrys"
                onChange={e => handleUpdate(e.target.name, e.target.checked)}
                inputProps={{ 'aria-label': 'controlled' }}
                color="primary"
              />
            </FormWrapper>
            <div className="spacer-5" /> */}

            <ReceptChooseDialog handleUpdateArray={handleUpdateArray} cook={cook} />
            <div className="spacer-5" />

            <TextField
              id="standard-basic" label="Kommentar" variant="standard"
              onChange={handleUpdateEvent}
              value={cook.kommentar}
              name="kommentar"
              multiline
              maxrows={4}
            />
            <div className="spacer-5" />

          </div>
        </DialogContent>
        <DialogActions className="CreateOrderDialog__buttons">
          <div className="flex-center">
            <Button onClick={handleClose}>Stäng</Button>
            {!newCook && <Button color="secondary" onClick={handleDelete}>Radera</Button>}
          </div>
          <Button color="primary" onClick={handleCreate}>Spara</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
